import { BomItemPointer } from 'model/Project/BomItemPointer'
import {
  BoMItemActivityDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemAllActivitiesSelector } from './allBomItemActivitiesSelector'

/**
 * Resolves an activity by working step type and its position among the
 * activities that share that type, e.g. the 2nd "Cleaning" activity.
 *
 * This is used to disambiguate between multiple activities of the same
 * working step type when there is no activity id to match against
 * (e.g. matching a copied/clipboard activity to the corresponding activity
 * on a different bom item, by relative position rather than always
 * resolving to the first one of that type).
 *
 * When the requested position doesn't exist (e.g. the target bom item has
 * fewer activities of that type than the source), falls back to the last
 * available activity of that type.
 */
export const bomItemActivityByWorkingStepPositionSelector =
  (
    bomItemPointer: BomItemPointer,
    workingStepType: WorkingStepType,
    position: number,
  ) =>
  (state: RootAppState): BoMItemActivityDto | undefined => {
    if (!bomItemPointer || !workingStepType) {
      return undefined
    }

    const activitiesOfType = (
      bomItemAllActivitiesSelector(bomItemPointer)(state) || []
    ).filter((activity) => activity.primaryWorkingStep === workingStepType)

    if (!activitiesOfType.length) {
      return undefined
    }

    return (
      activitiesOfType[position] ??
      activitiesOfType[activitiesOfType.length - 1]
    )
  }
